import { loadableWithRetry } from '../../common/utils/lazyLoad'

const routes = [
  {
    path: '/',
    component: loadableWithRetry(() => import('./FakeReview')),
    name: 'review',
    exact: true,
  },
]

export default routes
